import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Module } from '../models/module';

// Tipo para el estado del contexto
interface MenuContextType {
  modules: Module[];
  isLoading: boolean;
  setModules: React.Dispatch<React.SetStateAction<Module[]>>;
}

// Crear el contexto
const MenuContext = createContext<MenuContextType | undefined>(undefined);

// Propiedades para el proveedor del contexto
interface MenuProviderProps {
  children: ReactNode;
  initialModules: Module[];
}

// Proveedor del contexto
export const MenuProvider: React.FC<MenuProviderProps> = ({ children, initialModules }) => {
  const [modules, setModules] = useState<Module[]>(initialModules);
  const [isLoading] = useState<boolean>(false);

  return (
    <MenuContext.Provider value={{ modules, isLoading, setModules }}>
      {children}
    </MenuContext.Provider>
  );
};

export const useMenu = () => {
  const context = useContext(MenuContext);
  if (context === undefined) {
    throw new Error('useMenu must be used within a MenuProvider');
  }
  return context;
};
